module.exports = __webpack_public_path__ + "static/img/text5.c41fede.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/text5.png
// module id = gDzi
// module chunks = 1